module.exports = __webpack_public_path__ + "media/images/landing_options-17b7e137.svg";